@if (ready) {
  @let list = items;
  <div class="card mb-4">
    <div class="card-header pb-0 d-flex align-items-baseline gap-2">
      <h5 class="card-title mb-0">Pede ação agora</h5>
      @if (list.length) {
        <small class="act-count text-muted">{{ list.length }} {{ list.length === 1 ? 'item' : 'itens' }}</small>
      }
    </div>
    <div class="card-body">
      @if (list.length) {
        <div class="act-list">
          @for (i of visible(list); track i.key) {
            <a
              class="act-row"
              [routerLink]="i.link"
              [queryParams]="i.query"
              [ngbTooltip]="tip(i)"
              [disableTooltip]="!hoverCapable"
              container="body"
              placement="top-start"
            >
              <span
                class="act-dot"
                [class.act-dot--danger]="i.tone === 'danger'"
                [class.act-dot--warning]="i.tone === 'warning'"
                aria-hidden="true"
              ></span>
              <span class="act-value">{{ i.value }}</span>
              <span class="act-main">
                <span class="act-text">{{ i.short ?? i.text }}</span>
                @if (i.hint ?? i.detail; as secondary) {
                  <span class="act-hint">{{ secondary }}</span>
                }
              </span>
              <i class="ti ti-chevron-right act-go" aria-hidden="true"></i>
            </a>
          }
        </div>
        @if (list.length > limit) {
          <button type="button" class="act-more btn btn-link btn-sm p-0 mt-2" [attr.aria-expanded]="expanded" (click)="expanded = !expanded">
            {{ expanded ? 'Ver menos' : 'Ver mais ' + (list.length - limit) }}
          </button>
        }
      } @else {
        <p class="act-empty text-muted mb-0">Nada pede ação agora.</p>
      }
    </div>
  </div>
}
